import { render, staticRenderFns } from "./AIGeneratedFreestyleContent.vue?vue&type=template&id=455c7311&scoped=true"
import script from "./AIGeneratedFreestyleContent.vue?vue&type=script&lang=js"
export * from "./AIGeneratedFreestyleContent.vue?vue&type=script&lang=js"
import style0 from "./AIGeneratedFreestyleContent.vue?vue&type=style&index=0&id=455c7311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c7311",
  null
  
)

export default component.exports